import { render, staticRenderFns } from "./perdidoFilters.vue?vue&type=template&id=3390d54c"
import script from "./perdidoFilters.vue?vue&type=script&lang=js"
export * from "./perdidoFilters.vue?vue&type=script&lang=js"
import style0 from "./perdidoFilters.vue?vue&type=style&index=0&id=3390d54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports